var dialogService = angular.module('eficienciaFiscalModule');

dialogService.service('dialogService', ['$timeout', '$compile', function ($timeout, $compile) {
    this.initDialog = function (scope, options) {
        $('#' + options.divId).find('#btn-primary').attr("ng-click", options.primary_callback);
        $('#' + options.divId).find('#btn-primary').html(options.primary_text);

        $('#' + options.diagId).dialog({
            title: options.title,
            width: options.width || 300,
            modal: true,
            resizable: false,
            beforeClose: function () {
                if (options.beforeClose) {
                    return options.beforeClose()
                }
            },
            close: function () {
                $('#' + options.divId).remove();
                $('#' + options.diagId).each(function (index) {
                    $(this).remove();
                })
            }
        });

        $compile($('#' + options.diagId).contents())(scope)

        $('#' + options.diagId).dialog('open');
    };
}]);
